import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class TimeGap extends BasicEntity {
calendar: boolean | null;
code: string;
label: TranslatedEmb;
temporalWeight: number | null;
unit: string;
value: number | null;
}

